export default __webpack_public_path__ + "navigation-examples-route-deserialize-v1-960-35282794ea09a0804eefe4f8418f63c5.png";